export default __webpack_public_path__ + "static/media/landing-car.06f88a40.png";